// API client — Bearer token (localStorage 'auth_token').
const API = process.env.REACT_APP_BACKEND_URL;

export const API_URL = API;
const token = () => localStorage.getItem('auth_token');

const headers = () => ({
  'Content-Type': 'application/json',
  ...(token() ? { Authorization: `Bearer ${token()}` } : {}),
});

async function handle(res) {
  if (!res.ok) {
    let detail = 'Request failed';
    try { detail = (await res.json()).detail || detail; }
    catch (e) { console.warn('Non-JSON error response:', e?.message || e); }
    throw new Error(detail);
  }
  return res.json();
}

export const apiGet = (p) => fetch(`${API}/api${p}`, { headers: headers() }).then(handle);
export const apiPost = (p, b) => fetch(`${API}/api${p}`, { method: 'POST', headers: headers(), body: JSON.stringify(b) }).then(handle);
export const apiPatch = (p, b) => fetch(`${API}/api${p}`, { method: 'PATCH', headers: headers(), body: JSON.stringify(b) }).then(handle);
export const apiDelete = (p) => fetch(`${API}/api${p}`, { method: 'DELETE', headers: headers() }).then(handle);
